import { useAxios } from '@/composables/axios';
import type { ApiResponse } from '@/types/models';
import type { AppException } from '@/types/common';
import type { LoginResponseType, ResendVerificationDtoType, SignInDtoType } from '@nailsupply/review-swagger/auth';
import type { SocialLoginPayload } from './types';

// Shared auth API (thin axios) — endpoint đăng nhập/verify dùng chung nhiều
// nơi: useAuth (session core), useFullscreen (re-auth), staff-login. Thay cho api/AuthenService cũ.
export const authApis = () => {
  const { callAxios } = useAxios();

  const signin = (loginRequest: SignInDtoType) => {
    return callAxios<ApiResponse<LoginResponseType>>({
      API: '/api/v1/auth/signin',
      method: 'POST',
      body: loginRequest,
    });
  };

  const signinSocial = (endpoint: string, loginSocialRequest: SocialLoginPayload) => {
    return callAxios<ApiResponse<LoginResponseType>>({
      API: endpoint,
      method: 'POST',
      body: loginSocialRequest,
    });
  };

  const resendVerifyEmail = (req: ResendVerificationDtoType) => {
    return callAxios<ApiResponse | AppException>({
      API: '/api/v1/auth/resend-verification',
      method: 'POST',
      body: req,
    });
  };

  const loginPasscode = (identifier: string, passcode: string) => {
    return callAxios<ApiResponse<LoginResponseType> | AppException>({
      API: '/api/v1/auth/login-passcode',
      method: 'POST',
      body: {
        identifier,
        passcode,
      },
    });
  };

  return {
    signin,
    signinSocial,
    resendVerifyEmail,
    loginPasscode,
  };
};
